export function toHyphenCase(property) {
    return property.includes('-') ? property : property.replace(/[A-Z]/g, (c)=>`-${c.toLowerCase()}`);
}

//# sourceMappingURL=toHyphenCase.js.map